var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass:
        "button flex justify-center items-center h-10 w-10 rounded-full text-primary hover:text-primary-800 bg-white focus:outline-none",
      class: _vm.iconClasses,
      attrs: { type: "button" },
      on: { click: _vm.toggleFavoriteState },
    },
    [_c("HeartIcon", { staticClass: "h-4 w-4", class: _vm.iconClasses })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }